import { render, staticRenderFns } from "./userDashboardDocuments.vue?vue&type=template&id=eaba6e60"
import script from "./userDashboardDocuments.vue?vue&type=script&lang=js"
export * from "./userDashboardDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports